module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Submeter a ação para aprovação?"
    },
    on: {
      "yes": function($event) {
        return _vm.submeterAprovacao()
      }
    },
    model: {
      value: (_vm.dialogSubmeterAprovacao),
      callback: function($$v) {
        _vm.dialogSubmeterAprovacao = $$v
      },
      expression: "dialogSubmeterAprovacao"
    }
  }, [_vm._v("\n    O cadastro da ação nesta plataforma não garante o registro! É necessário autuar um processo digital (com PDF da ação em anexo) na secretaria do setor de lotação do coordenador e aguardar deliberação da Câmara de Extensão. Maiores informações entre em contato através do e-mail suporte.proex@ufes.br\n  ")]), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Submeter a ação e o relatório para aprovação?"
    },
    on: {
      "yes": function($event) {
        return _vm.submeterAprovacao()
      }
    },
    model: {
      value: (_vm.dialogSubmeterAprovacaoAcaoRegistroTardio),
      callback: function($$v) {
        _vm.dialogSubmeterAprovacaoAcaoRegistroTardio = $$v
      },
      expression: "dialogSubmeterAprovacaoAcaoRegistroTardio"
    }
  }, [_vm._v("\n    O cadastro da ação e o preenchimento do relatório nesta plataforma não garantem o registro! É necessário autuar um processo digital contendo o PDF da ação, o PDF do relatório e a documentação comprobatória na secretaria do setor de lotação do coordenador e aguardar deliberação da Câmara de Extensão. Maiores informações entre em contato através do e-mail suporte.proex@ufes.br\n  ")]), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Concluir importação?"
    },
    on: {
      "yes": function($event) {
        return _vm.concluirImportacao()
      }
    },
    model: {
      value: (_vm.dialogConcluirImportacao),
      callback: function($$v) {
        _vm.dialogConcluirImportacao = $$v
      },
      expression: "dialogConcluirImportacao"
    }
  }, [_vm._v("\n    Depois que a importação for concluída a ação de extensão importada do SIEX passará para a situação \"Ativa\" no novo portal de projetos.\n  ")]), _vm._v(" "), _c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a ação?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirAcao()
      }
    },
    model: {
      value: (_vm.dialogExclusao),
      callback: function($$v) {
        _vm.dialogExclusao = $$v
      },
      expression: "dialogExclusao"
    }
  }, [_vm._v("\n    Essa ação será excluída após clicar na opção \"Sim\".\n  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.administrador === true || _vm.projeto.assessor === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1)) ? _c('v-card-actions', [(_vm.projeto.situacao.item === 15 && (_vm.projeto.registroTardio === false || _vm.projeto.registroTardio === true && _vm.projeto.relatorioFinalHabilitado === true) && !_vm.extensao.registroSIEX) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.administrador === false && _vm.projeto.assessor === true,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoSubmeterAprovacao()
      }
    }
  }, [_vm._v("Submeter para aprovação")]) : _vm._e(), _vm._v(" "), (_vm.projeto.situacao.item === 15 && _vm.extensao.registroSIEX) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.administrador === false && _vm.projeto.assessor === true,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoConcluirImportacao()
      }
    }
  }, [_vm._v("Concluir Importação")]) : _vm._e(), _vm._v(" "), (_vm.projeto.situacao.item === 16 && !_vm.extensao.registroSIEX) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "slot": "activator",
      "disabled": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoSubmeterAprovacao()
      }
    },
    slot: "activator"
  }, [_vm._v("Submeter para aprovação")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }), _vm._v(" "), _c('span', [_vm._v("Essa ação já foi submetida para aprovação!")])], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.situacao.item === 15 && _vm.projeto.registroTardio === true && _vm.projeto.relatorioFinalHabilitado === false) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "float": "left"
          }
        }, on), [_c('v-btn', {
          staticClass: "text-xs-right, botaoSubmeterAprovacaoDesabilitado",
          attrs: {
            "disabled": "",
            "color": "primary"
          }
        }, [_vm._v("Submeter para aprovação")])], 1)]
      }
    }], null, false, 3586984127)
  }, [_vm._v(" "), _c('span', [_vm._v("O administrador (PROEX) precisa primeiramente liberar o preenchimento do relatório técnico final!")])]) : _vm._e(), _vm._v(" "), (_vm.projeto.situacao.item === 16 && _vm.extensao.registroSIEX) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "slot": "activator",
      "disabled": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoConcluirImportacao()
      }
    },
    slot: "activator"
  }, [_vm._v("Concluir Importação")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }), _vm._v(" "), _c('span', [_vm._v("A importação já foi submetida!")])], 1) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoFinalizarAcao === true && _vm.projeto.situacao.item === 18) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.administrador === false && _vm.projeto.assessor === true,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.botaoFinalizarAcao()
      }
    }
  }, [_vm._v("Finalizar Ação")]) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoGerarPDFAcao === true && _vm.projeto.situacao.item !== 15) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorio
    }
  }, [_vm._v("Gerar PDF da Ação")]) : _vm._e(), _vm._v(" "), ((_vm.administrador === true && (_vm.projeto.situacao.item === 15 || _vm.projeto.situacao.item === 16)) || ((_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) && _vm.projeto.situacao.item === 15)) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "disabled": _vm.administrador === false && _vm.projeto.assessor === true,
      "color": "red lighten-1 white--text"
    },
    on: {
      "click": function($event) {
        return _vm.botaoExcluirAcao()
      }
    }
  }, [_vm._v("Excluir ação")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.editar != null) ? _c('div', [(_vm.administrador === true || _vm.projeto.situacao.item !== 16) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toEditar
    }
  }, [_vm._v(_vm._s(this.nome_editar == null ? 'Editar' : this.nome_editar))]) : _vm._e(), _vm._v(" "), (_vm.administrador !== true && _vm.projeto.situacao.item === 16) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "disabled": "",
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toEditar
    },
    slot: "activator"
  }, [_vm._v(_vm._s(this.nome_editar == null ? 'Editar' : this.nome_editar))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }), _vm._v(" "), _c('span', [_vm._v("Não é possível editar uma ação aguardando aprovação!")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.proxima != null) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.habilitaBotaoGerarPDFAcao === true && _vm.administrador === false && (_vm.projeto.funcao == null || _vm.projeto.funcao.item !== 1) && _vm.projeto.assessor === false) ? _c('v-card-actions', [(_vm.usuarioPROEX === true && _vm.projeto.situacao.item !== 15 && _vm.projeto.situacao.item !== 16) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.toRelatorio
    }
  }, [_vm._v("Gerar PDF da Ação")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.proxima != null) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toAvancar
    }
  }, [_vm._v("Avançar")]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-008580cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-card-footer.vue
// module id = 453
// module chunks = 0